import React from "react";
import logoHeader from "../assets/logo-header.png";
import { useState } from "react";
import menuImg from "../assets/menu.png";
import phone from "../assets/phone.png";
import email from "../assets/email.png";
import fb from "../assets/fb.png";
import insta from "../assets/insta.png";
import linkedin from "../assets/linkedin.png";
import { Link } from "react-router-dom";

export const Header = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const navItems = [
    { label: "Home", to: "/" },
    { label: "About us", to: "/about" },
    { label: "What we do", to: "/services" },
    { label: "Our Projects", to: "/projects" },
    { label: "Contact us", to: "/contact" },
  ];
  return (
    <div>
      <header className="bg-white shadow">
        <div className="flex items-center justify-center p-2 bg-blue-900">
          <div className="flex font-size-para flex-col md:flex-row items-center gap-2 md:gap-8 text-white text-sm">
            <a
              href="mailto:bhagwatiengineering76@gmail.com"
              data-aos="zoom-out-up"
              className="flex items-center"
            >
              <img className="mr-3" src={email} alt="email" />{" "}
              bhagwatiengineering76@gmail.com
            </a>
            <a
              href="tel:+918291724184"
              data-aos="zoom-out-up"
              className="flex items-center"
            >
              <img className="mr-3" src={phone} alt="phone" /> +91 8291724184
            </a>
          </div>
        </div>
      </header>
      <div className="flex justify-between nav-padding">
        <div className="flex items-center">
          <Link to="/">
            <img
              src={logoHeader}
              alt="BE Logo"
              className="h-20"
            />
          </Link>
        </div>
        <div className="flex">
          <button onClick={() => setIsSidebarOpen(true)} className="text-2xl">
            <img
              className="menu-img"
              src={menuImg}
              alt=""
            />
          </button>
        </div>
      </div>
      {/* Slide-out Sidebar */}
      <div
        className={`fixed top-0 right-0 h-full w-72 bg-white shadow-lg transform transition-transform duration-300 z-50 ${
          isSidebarOpen ? "translate-x-0" : "translate-x-full"
        }`}
      >
        {/* Close button */}
        <div className="flex justify-end p-4">
          <button onClick={() => setIsSidebarOpen(false)} className="text-2xl">
            ✕
          </button>
        </div>

        {/* Nav Links */}
        <nav className="nav-item-link">
          {navItems.map(({ label, to }) => (
            <Link key={to} to={to} onClick={() => setIsSidebarOpen(false)}>
              {label}
            </Link>
          ))}
        </nav>

        {/* Social Icons */}
        <div className="flex justify-center gap-4 mt-16">
          <a
            href="https://instagram.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={insta} alt="Instagram" className="h-9 w-9" />
          </a>
          <a
            href="https://linkedin.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={linkedin} alt="LinkedIn" className="h-9 w-9" />
          </a>
          <a
            href="https://www.facebook.com/farhan.mohammed.5836/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={fb} alt="Facebook" className="h-9 w-9" />
          </a>
        </div>
      </div>
      {/* Backdrop */}
      {isSidebarOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40"
          onClick={() => setIsSidebarOpen(false)}
        ></div>
      )}
    </div>
  );
};
